import React, { useState } from 'react';
import { Box, Button, Typography, CircularProgress, Icon, InputAdornment, TextField } from '@material-ui/core';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import 'moment/locale/es';

const ExtendMembership = ({ student, loading, onConfirm, disabled }) => {
    const [selectedDate, setSelectedDate] = useState(null);

    // The new expiration date can never be earlier than the membership's current
    // end date. We use it as the calendar's minimum (blocks earlier days) and as
    // its initial focus. Falls back to today if the student has no valid end date.
    const membershipEnd = moment(student.end_date_membership);
    const minSelectableDate = membershipEnd.isValid()
        ? membershipEnd.toDate()
        : new Date();

    const handleConfirm = () => {
        if (!selectedDate) return;
        const formattedDate = moment(selectedDate).format('YYYY-MM-DD') + ' 23:59:59';
        onConfirm(student, formattedDate);
    };

    return (
        <Box>
            <Typography variant="body2" color="textSecondary" gutterBottom>
                Seleccione la nueva fecha de vencimiento para <strong>{student.first_name} {student.last_name}</strong>.
                {membershipEnd.isValid() && (
                    <> La membresía vence actualmente el <strong>{membershipEnd.format('DD/MM/YYYY')}</strong>; no se puede seleccionar una fecha anterior.</>
                )}
            </Typography>
            <Box mt={2} maxWidth={300}>
                <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale="es">
                    <DatePicker
                        label="Nueva fecha de vencimiento"
                        inputVariant="outlined"
                        margin="dense"
                        fullWidth
                        value={selectedDate}
                        onChange={(date) => setSelectedDate(date)}
                        format="DD/MM/YYYY"
                        placeholder="DD/MM/YYYY"
                        variant="dialog"
                        autoOk={false}
                        openTo="year"
                        views={['year', 'month', 'date']}
                        minDate={minSelectableDate}
                        initialFocusedDate={minSelectableDate}
                        disabled={disabled || loading}
                        okLabel="OK"
                        cancelLabel="Cancel"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Icon
                                        className="ri-calendar-2-line text-dark-black-200 mr-1"
                                        style={{ fontSize: 18 }}
                                    />
                                </InputAdornment>
                            ),
                        }}
                        TextFieldComponent={(params) => <TextField {...params} />}
                    />
                </MuiPickersUtilsProvider>
            </Box>
            <Box mt={2}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleConfirm}
                    disabled={disabled || loading || !selectedDate}
                    startIcon={loading ? <CircularProgress size={16} /> : null}
                >
                    {loading ? 'Procesando...' : 'Confirmar Extensión'}
                </Button>
            </Box>
        </Box>
    );
};

export default ExtendMembership;
